import { Get } from "../utils/api";
import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import { PutAddressBody } from "./usePutAddress";

export default (organizationId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<PutAddressBody[]>(
    `addresses-${organizationId}`,
    async () => {
      return await Get<PutAddressBody[]>(
        `/api/address/organization/${organizationId}`,
        await getAccessTokenSilently()
      );
    },
    { cacheTime: 0, enabled: !!organizationId }
  );
};
